import * as React from 'react';
import RatesTableHeader from 'app/pages/AgentPricing/components/RatesTableWidget/RatesTableHeader';
import RatesTableRow from 'app/pages/AgentPricing/components/RatesTableWidget/RatesTableRow';
import './RatesTableWidget.css'
import { DiscountDatesDisplay } from 'app/pages/AgentPricing/components/RatesTableWidget/DiscountDatesDisplay';
import { DiscountDatesEditor } from 'app/pages/AgentPricing/components/RatesTableWidget/DiscountDatesEditor';
import { RatesTable, RatesColumn } from 'app/pages/AgentPricing/models';
import { RatesHighlight } from 'app/pages/AgentPricing/modules/RatesTableWidget/state';


export interface RatesTableWidgetProps {
    readonly?: boolean
    table: RatesTable,
    columns: RatesColumn[],
    highlightInfo: RatesHighlight,
    onChangeRate: (columnId: string, rowId: string, rate: string) => void,
    onChangeStartDate: (newDate: string) => void,
    onChangeEndDate?: (newDate: string | null) => void
}

function DiscountDates(props: RatesTableWidgetProps) {
    if (props.readonly)
        return <DiscountDatesDisplay status={props.table.status} dates={props.table.dates} />

    return <DiscountDatesEditor
            dates={props.table.dates}
            status={props.table.status}
            changeStartDate={props.onChangeStartDate}
            changeEndDate={props.onChangeEndDate ?? (() => {})}
    />;
}

export const RatesTableWidget = (props:RatesTableWidgetProps) => (
    <div className="rates-container">
        {DiscountDates(props)}
        <div className="rates-viewport">
            <table className="rates-table">
                <colgroup>
                    <col />
                    {
                        props.columns.map(x => {
                            return <col key={x.id} className={props.highlightInfo.columnId === x.id ? 'selected' : undefined} />
                        })
                    }
                </colgroup>
                <RatesTableHeader 
                    countries={props.table.countries} 
                    columns={props.columns} 
                    highlightColumnId={props.highlightInfo.columnId }
                    />
                <tbody> 
                    {props.table.rules.map((x, index) => {
                        return <RatesTableRow 
                                    onChangeRate={props.onChangeRate}
                                    readonly={props.readonly}
                                    key={x.code}
                                    rule={x}
                                    columns={props.columns}
                                    rates={props.table.rates}
                                    selected={props.highlightInfo.ruleCode === x.code}
                                    highlightColumnId={props.highlightInfo.columnId} />
                    })}       
                </tbody>
            </table>
        </div>
    </div>
);
